export default __webpack_public_path__ + "static/media/cruiser_class_params.b83a5ba9.png";